var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarvector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.39,
    y: 393.28,
    width: 24.83,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.56,
    y: 393.15,
    width: 8.39,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.04,
    y: 394.83,
    width: 51.99,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.02,
    y: 397.54,
    width: 7.75,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.59,
    y: 389.63,
    width: 13.36,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 389.63,
    width: 67.76,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.36,
    y: 395.67,
    width: 47.14,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.75,
    y: 318.28,
    width: 35.33,
    height: 64.12,
    transform: "translate(718.83 700.68) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.08,
    y: 318.28,
    width: 42.15,
    height: 64.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.75,
    y: 323.7,
    width: 77.85,
    height: 2.9,
    transform: "translate(761.35 650.31) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.8,
    y: 311.57,
    width: 37.28,
    height: 13.36,
    transform: "translate(716.88 636.49) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.08,
    y: 311.57,
    width: 44.1,
    height: 13.36,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.13,
    y: 73.99,
    width: 118.93,
    height: 141.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.68,
    y: 73.99,
    width: 121.83,
    height: 141.9,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.13,
    y: 215.89,
    width: 118.93,
    height: 10.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 215.89,
    width: 121.83,
    height: 10.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.26,
    y: 91.64,
    width: 126.66,
    height: 106.59,
    transform: "translate(283.53 6.35) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.38 208.27 143.09 81.61 164.19 81.61 119.49 208.27 98.38 208.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.82,165.3a.55.55,0,0,1-.54-.55V86.56a.54.54,0,0,1,.54-.54.55.55,0,0,1,.55.54v78.19A.55.55,0,0,1,88.82,165.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.02 208.27 168.73 81.61 176.96 81.61 132.25 208.27 124.02 208.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 144.46,
    width: 126.66,
    height: 0.97,
    transform: "translate(336.34 -46.46) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.3 91.35 82.38 91.35 81.68 84.57 200.6 84.57 201.3 91.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.3 96.32 82.38 96.32 81.68 89.53 200.6 89.53 201.3 96.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.3 102.28 82.38 102.28 81.68 95.49 200.6 95.49 201.3 102.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.3 108.91 82.38 108.91 81.68 102.13 200.6 102.13 201.3 108.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.3 116.86 82.38 116.86 81.68 110.07 200.6 110.07 201.3 116.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.3 125.79 82.38 125.79 81.68 119.01 200.6 119.01 201.3 125.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.43,
    y: 73.99,
    width: 118.93,
    height: 141.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.97,
    y: 73.99,
    width: 121.83,
    height: 141.9,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.43,
    y: 215.89,
    width: 118.93,
    height: 10.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.04,
    y: 215.89,
    width: 121.83,
    height: 10.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.56,
    y: 91.64,
    width: 126.66,
    height: 106.59,
    transform: "translate(499.83 -209.95) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.68 208.27 359.39 81.61 380.49 81.61 335.78 208.27 314.68 208.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.12,165.3a.55.55,0,0,1-.54-.55V86.56a.54.54,0,0,1,1.08,0v78.19A.55.55,0,0,1,305.12,165.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.32 208.27 385.03 81.61 393.25 81.61 348.55 208.27 340.32 208.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.37,
    y: 144.46,
    width: 126.66,
    height: 0.97,
    transform: "translate(552.64 -262.76) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.6 91.35 298.68 91.35 297.97 84.57 416.9 84.57 417.6 91.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.6 96.32 298.68 96.32 297.97 89.53 416.9 89.53 417.6 96.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.6 102.28 298.68 102.28 297.97 95.49 416.9 95.49 417.6 102.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.6 108.91 298.68 108.91 297.97 102.13 416.9 102.13 417.6 108.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.6 116.86 298.68 116.86 297.97 110.07 416.9 110.07 417.6 116.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.6 125.79 298.68 125.79 297.97 119.01 416.9 119.01 417.6 125.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.29,
    y: 292.46,
    width: 23.75,
    height: 89.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.52 382.4 318.03 382.4 318.03 371.38 308.79 371.38 313.52 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.81,
    y: 292.46,
    width: 23.75,
    height: 89.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.62,
    y: 292.46,
    width: 234.42,
    height: 83.88,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.48,
    y: 270.51,
    width: 59.9,
    height: 112.2,
    transform: "translate(-68.17 585.04) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.26,
    y: 270.51,
    width: 59.9,
    height: 112.2,
    transform: "translate(-183.39 469.82) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.1,
    y: 309.79,
    width: 6.67,
    height: 112.2,
    transform: "translate(624.32 107.45) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.88,
    y: 309.79,
    width: 6.67,
    height: 112.2,
    transform: "translate(509.1 222.68) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.73,300.24h-79a13,13,0,0,1-9.39-4h97.82A13,13,0,0,1,182.73,300.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.37,300.24h-79a13,13,0,0,1-9.39-4h97.82A12.94,12.94,0,0,1,298.37,300.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.13 382.4 83.61 382.4 83.61 371.38 92.85 371.38 88.13 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.12,
    y: 237.24,
    width: 26.44,
    height: 55.22,
    style: {
      fill: "#e0e0e0",
      opacity: 0.4,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.77 292.46 233.02 292.46 228.81 232.83 273.55 232.83 277.77 292.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.86 292.46 234.29 292.46 230.08 232.83 278.64 232.83 282.86 292.46",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.54 290.18 232.65 235.11 276.4 235.11 280.3 290.18 236.54 290.18",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.13 277.85 244.98 247.44 265.81 247.44 267.96 277.85 247.13 277.85",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.35,
    cy: 271.05,
    r: 11.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.25,
    cy: 276.59,
    r: 11.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.07,
    cy: 271.75,
    r: 7.75,
    transform: "translate(-88.73 95.16) rotate(-22.39)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.98,
    cy: 264,
    r: 7.75,
    transform: "translate(-116.95 390.6) rotate(-80.8)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,274.51s.91,17.95,35.78,17.95,35.78-17.95,35.78-17.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.57,286.31s-11.36-19.58,4.4-35.17c0,0,4.11,2.68,4,6.29s-4.41,4.51-3.48,7.52,5,6,2.35,8.45.43,4.69.25,7.74S108.57,286.31,108.57,286.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,288.1s4.6-22.16-15.27-32c0,0-3.06,3.85-1.86,7.25s5.6,2.89,5.67,6-2.9,7.24.44,8.75,1.07,4.6,2.2,7.43S109.43,288.1,109.43,288.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,277.85s.38,14.61,14.86,14.61,14.86-14.61,14.86-14.61Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.45,272.44a2.34,2.34,0,0,1,0-4.67c5.72,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C195.66,262.53,189,272.44,180.45,272.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,272.44a2.34,2.34,0,0,1,0-4.67c5.72,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C231,262.53,224.27,272.44,215.74,272.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,272.44a2.34,2.34,0,0,1,0-4.67c5.71,0,10.54-8.19,10.54-17.89a2.33,2.33,0,0,1,4.66,0C266.23,262.53,259.56,272.44,251,272.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,272.44a2.34,2.34,0,1,1,0-4.67c5.71,0,10.54-8.19,10.54-17.89a2.33,2.33,0,0,1,4.66,0C301.52,262.53,294.84,272.44,286.32,272.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.6,272.44a2.34,2.34,0,0,1,0-4.67c5.72,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C336.81,262.53,330.13,272.44,321.6,272.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.89,272.44a2.34,2.34,0,0,1,0-4.67c5.71,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C372.1,262.53,365.42,272.44,356.89,272.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.45,272.44a2.34,2.34,0,0,1,0-4.67c5.72,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C195.66,262.53,189,272.44,180.45,272.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74,272.44a2.34,2.34,0,0,1,0-4.67c5.72,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C231,262.53,224.27,272.44,215.74,272.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251,272.44a2.34,2.34,0,0,1,0-4.67c5.71,0,10.54-8.19,10.54-17.89a2.33,2.33,0,0,1,4.66,0C266.23,262.53,259.56,272.44,251,272.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.32,272.44a2.34,2.34,0,1,1,0-4.67c5.71,0,10.54-8.19,10.54-17.89a2.33,2.33,0,0,1,4.66,0C301.52,262.53,294.84,272.44,286.32,272.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.6,272.44a2.34,2.34,0,0,1,0-4.67c5.72,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C336.81,262.53,330.13,272.44,321.6,272.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M356.89,272.44a2.34,2.34,0,0,1,0-4.67c5.71,0,10.54-8.19,10.54-17.89a2.34,2.34,0,0,1,4.67,0C372.1,262.53,365.42,272.44,356.89,272.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.34,252.27H385.52a12.51,12.51,0,0,1,12.19,11.19l12.58,141.83a10.11,10.11,0,0,1-10.2,11.19H172.9a12.53,12.53,0,0,1-12.19-11.19L148.14,263.46A10.1,10.1,0,0,1,158.34,252.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.34,252.27H385.52a12.51,12.51,0,0,1,12.19,11.19l12.58,141.83a10.11,10.11,0,0,1-10.2,11.19H172.9a12.53,12.53,0,0,1-12.19-11.19L148.14,263.46A10.1,10.1,0,0,1,158.34,252.27Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63,252.27H156.44a11.86,11.86,0,0,0-11.7,11.19l-6.4,141.83A10.63,10.63,0,0,0,149,416.48H376.21a11.86,11.86,0,0,0,11.7-11.19l6.41-141.83A10.64,10.64,0,0,0,383.63,252.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63,252.27H156.44a11.86,11.86,0,0,0-11.7,11.19l-6.4,141.83A10.63,10.63,0,0,0,149,416.48H376.21a11.86,11.86,0,0,0,11.7-11.19l6.41-141.83A10.64,10.64,0,0,0,383.63,252.27Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.61,379l5.29-117.13a4.53,4.53,0,0,1,4.48-4.28H369.21a4.07,4.07,0,0,1,4.09,4.28L368,379a4.53,4.53,0,0,1-4.48,4.28H164.7A4.07,4.07,0,0,1,160.61,379Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.61,379l5.29-117.13a4.53,4.53,0,0,1,4.48-4.28H369.21a4.07,4.07,0,0,1,4.09,4.28L368,379a4.53,4.53,0,0,1-4.48,4.28H164.7A4.07,4.07,0,0,1,160.61,379Z",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,388.56l5.55-123a4.74,4.74,0,0,1,4.7-4.49H374.05a4.26,4.26,0,0,1,4.29,4.49l-5.56,123a4.75,4.75,0,0,1-4.69,4.5H159.27A4.25,4.25,0,0,1,155,388.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.84,398.48l5.79-128.3a5,5,0,0,1,4.9-4.69H378.34a4.45,4.45,0,0,1,4.48,4.69L377,398.48a5,5,0,0,1-4.9,4.69H154.32A4.44,4.44,0,0,1,149.84,398.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.86,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.15,3.15,0,0,1,356.86,273.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.57,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,321.57,273.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.28,273.18h0a3,3,0,0,1-3-3.18h0a3.16,3.16,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,286.28,273.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,273.18h0a3,3,0,0,1-3-3.18h0a3.17,3.17,0,0,1,3.12-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,251,273.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.71,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.15,3.15,0,0,1,215.71,273.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.42,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,180.42,273.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.86,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.15,3.15,0,0,1,356.86,273.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.57,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,321.57,273.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.28,273.18h0a3,3,0,0,1-3-3.18h0a3.16,3.16,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,286.28,273.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,273.18h0a3,3,0,0,1-3-3.18h0a3.17,3.17,0,0,1,3.12-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,251,273.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.71,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.15,3.15,0,0,1,215.71,273.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.42,273.18h0a3,3,0,0,1-3-3.18h0a3.15,3.15,0,0,1,3.11-3h0a3,3,0,0,1,3,3.18h0A3.14,3.14,0,0,1,180.42,273.18Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,284.36H171.49a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2-2h17.75a1.86,1.86,0,0,1,1.87,2h0A2.08,2.08,0,0,1,189.24,284.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.53,284.36H206.78a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2.05-2H224.7a1.87,1.87,0,0,1,1.88,2h0A2.08,2.08,0,0,1,224.53,284.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,284.36H242.07a1.87,1.87,0,0,1-1.88-2h0a2.08,2.08,0,0,1,2.05-2H260a1.86,1.86,0,0,1,1.87,2h0A2.07,2.07,0,0,1,259.82,284.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.1,284.36H277.35a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2-2h17.75a1.86,1.86,0,0,1,1.87,2h0A2.08,2.08,0,0,1,295.1,284.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.39,284.36H312.64a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2.05-2h17.75a1.86,1.86,0,0,1,1.87,2h0A2.08,2.08,0,0,1,330.39,284.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.68,284.36H347.93a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2.05-2h17.74a1.87,1.87,0,0,1,1.88,2h0A2.08,2.08,0,0,1,365.68,284.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.24,284.36H171.49a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2-2h17.75a1.86,1.86,0,0,1,1.87,2h0A2.08,2.08,0,0,1,189.24,284.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224.53,284.36H206.78a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2.05-2H224.7a1.87,1.87,0,0,1,1.88,2h0A2.08,2.08,0,0,1,224.53,284.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M259.82,284.36H242.07a1.87,1.87,0,0,1-1.88-2h0a2.08,2.08,0,0,1,2.05-2H260a1.86,1.86,0,0,1,1.87,2h0A2.07,2.07,0,0,1,259.82,284.36Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.1,284.36H277.35a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2-2h17.75a1.86,1.86,0,0,1,1.87,2h0A2.08,2.08,0,0,1,295.1,284.36Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M330.39,284.36H312.64a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2.05-2h17.75a1.86,1.86,0,0,1,1.87,2h0A2.08,2.08,0,0,1,330.39,284.36Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M365.68,284.36H347.93a1.86,1.86,0,0,1-1.87-2h0a2.08,2.08,0,0,1,2.05-2h17.74a1.87,1.87,0,0,1,1.88,2h0A2.08,2.08,0,0,1,365.68,284.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,322.13H167.1a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.12a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.17,4.17,0,0,1,190.22,322.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,322.13H202.39a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92H226.9a3.74,3.74,0,0,1,3.75,3.92l-1.05,23.12A4.15,4.15,0,0,1,225.51,322.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,322.13H237.68a3.74,3.74,0,0,1-3.75-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.72,3.72,0,0,1,3.74,3.92l-1,23.12A4.16,4.16,0,0,1,260.79,322.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,322.13H273a3.73,3.73,0,0,1-3.75-3.92l1-23.12a4.15,4.15,0,0,1,4.09-3.92h23.12a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.16,4.16,0,0,1,296.08,322.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,322.13H308.25a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.73,3.73,0,0,1,3.75,3.92l-1,23.12A4.17,4.17,0,0,1,331.37,322.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.65,322.13H343.54a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.74,3.74,0,0,1,3.75,3.92l-1.05,23.12A4.15,4.15,0,0,1,366.65,322.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.22,322.13H167.1a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.12a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.17,4.17,0,0,1,190.22,322.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,322.13H202.39a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92H226.9a3.74,3.74,0,0,1,3.75,3.92l-1.05,23.12A4.15,4.15,0,0,1,225.51,322.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,322.13H237.68a3.74,3.74,0,0,1-3.75-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.72,3.72,0,0,1,3.74,3.92l-1,23.12A4.16,4.16,0,0,1,260.79,322.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,322.13H273a3.73,3.73,0,0,1-3.75-3.92l1-23.12a4.15,4.15,0,0,1,4.09-3.92h23.12a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.16,4.16,0,0,1,296.08,322.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,322.13H308.25a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.73,3.73,0,0,1,3.75,3.92l-1,23.12A4.17,4.17,0,0,1,331.37,322.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.65,322.13H343.54a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.74,3.74,0,0,1,3.75,3.92l-1.05,23.12A4.15,4.15,0,0,1,366.65,322.13Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.6,358H165.48a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.17,4.17,0,0,1,4.1-3.92H190a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.17,4.17,0,0,1,188.6,358Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.89,358H200.77a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11A3.74,3.74,0,0,1,229,331L228,354.08A4.15,4.15,0,0,1,223.89,358Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.17,358H236.06a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.72,3.72,0,0,1,3.74,3.92l-1,23.12A4.16,4.16,0,0,1,259.17,358Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.46,358H271.35a3.74,3.74,0,0,1-3.75-3.92l1-23.12a4.15,4.15,0,0,1,4.09-3.92h23.12A3.73,3.73,0,0,1,299.6,331l-1,23.12A4.16,4.16,0,0,1,294.46,358Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.75,358H306.63a3.73,3.73,0,0,1-3.74-3.92l1-23.12A4.17,4.17,0,0,1,308,327h23.12a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.17,4.17,0,0,1,329.75,358Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,358H341.92a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.74,3.74,0,0,1,3.75,3.92l-1.05,23.12A4.15,4.15,0,0,1,365,358Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.6,358H165.48a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.17,4.17,0,0,1,4.1-3.92H190a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.17,4.17,0,0,1,188.6,358Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.89,358H200.77a3.73,3.73,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11A3.74,3.74,0,0,1,229,331L228,354.08A4.15,4.15,0,0,1,223.89,358Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.17,358H236.06a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.72,3.72,0,0,1,3.74,3.92l-1,23.12A4.16,4.16,0,0,1,259.17,358Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.46,358H271.35a3.74,3.74,0,0,1-3.75-3.92l1-23.12a4.15,4.15,0,0,1,4.09-3.92h23.12A3.73,3.73,0,0,1,299.6,331l-1,23.12A4.16,4.16,0,0,1,294.46,358Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.75,358H306.63a3.73,3.73,0,0,1-3.74-3.92l1-23.12A4.17,4.17,0,0,1,308,327h23.12a3.73,3.73,0,0,1,3.74,3.92l-1,23.12A4.17,4.17,0,0,1,329.75,358Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,358H341.92a3.72,3.72,0,0,1-3.74-3.92l1-23.12a4.16,4.16,0,0,1,4.1-3.92h23.11a3.74,3.74,0,0,1,3.75,3.92l-1.05,23.12A4.15,4.15,0,0,1,365,358Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187,393.86H163.86a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.16,4.16,0,0,1,4.1-3.92h23.12a3.72,3.72,0,0,1,3.74,3.92l-1,23.11A4.15,4.15,0,0,1,187,393.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.27,393.86H199.15a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.15,4.15,0,0,1,4.1-3.92h23.11a3.72,3.72,0,0,1,3.75,3.92l-1,23.11A4.14,4.14,0,0,1,222.27,393.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.55,393.86H234.44a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.15,4.15,0,0,1,4.1-3.92H259a3.73,3.73,0,0,1,3.75,3.92l-1.05,23.11A4.15,4.15,0,0,1,257.55,393.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.84,393.86H269.73a3.73,3.73,0,0,1-3.75-3.92l1-23.11a4.14,4.14,0,0,1,4.09-3.92h23.12a3.72,3.72,0,0,1,3.74,3.92l-1,23.11A4.15,4.15,0,0,1,292.84,393.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,393.86H305a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.16,4.16,0,0,1,4.1-3.92h23.12a3.72,3.72,0,0,1,3.74,3.92l-1,23.11A4.16,4.16,0,0,1,328.13,393.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,393.86H340.3a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.15,4.15,0,0,1,4.1-3.92h23.11a3.73,3.73,0,0,1,3.75,3.92l-1.05,23.11A4.14,4.14,0,0,1,363.42,393.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,393.86H163.86a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.16,4.16,0,0,1,4.1-3.92h23.12a3.72,3.72,0,0,1,3.74,3.92l-1,23.11A4.15,4.15,0,0,1,187,393.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.27,393.86H199.15a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.15,4.15,0,0,1,4.1-3.92h23.11a3.72,3.72,0,0,1,3.75,3.92l-1,23.11A4.14,4.14,0,0,1,222.27,393.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.55,393.86H234.44a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.15,4.15,0,0,1,4.1-3.92H259a3.73,3.73,0,0,1,3.75,3.92l-1.05,23.11A4.15,4.15,0,0,1,257.55,393.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.84,393.86H269.73a3.73,3.73,0,0,1-3.75-3.92l1-23.11a4.14,4.14,0,0,1,4.09-3.92h23.12a3.72,3.72,0,0,1,3.74,3.92l-1,23.11A4.15,4.15,0,0,1,292.84,393.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,393.86H305a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.16,4.16,0,0,1,4.1-3.92h23.12a3.72,3.72,0,0,1,3.74,3.92l-1,23.11A4.16,4.16,0,0,1,328.13,393.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,393.86H340.3a3.72,3.72,0,0,1-3.74-3.92l1-23.11a4.15,4.15,0,0,1,4.1-3.92h23.11a3.73,3.73,0,0,1,3.75,3.92l-1.05,23.11A4.14,4.14,0,0,1,363.42,393.86Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55,15.21,9.91,15.21,22.55a2.34,2.34,0,0,1-4.67,0c0-9.69-4.82-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,1,1,0,4.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55S231,237.24,231,249.88a2.34,2.34,0,0,1-4.67,0c0-9.69-4.82-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,272.44c-8.53,0-15.21-9.91-15.21-22.56s6.68-22.55,15.21-22.55,15.2,9.91,15.2,22.55a2.33,2.33,0,0,1-4.66,0c0-9.69-4.83-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,272.44c-8.53,0-15.21-9.91-15.21-22.56s6.68-22.55,15.21-22.55,15.2,9.91,15.2,22.55a2.33,2.33,0,0,1-4.66,0c0-9.69-4.83-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.82,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.6,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55,15.21,9.91,15.21,22.55a2.34,2.34,0,0,1-4.67,0c0-9.69-4.82-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,1,1,0,4.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.89,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55,15.21,9.91,15.21,22.55a2.34,2.34,0,0,1-4.67,0c0-9.69-4.83-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.45,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55,15.21,9.91,15.21,22.55a2.34,2.34,0,0,1-4.67,0c0-9.69-4.82-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,1,1,0,4.67Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55S231,237.24,231,249.88a2.34,2.34,0,0,1-4.67,0c0-9.69-4.82-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251,272.44c-8.53,0-15.21-9.91-15.21-22.56s6.68-22.55,15.21-22.55,15.2,9.91,15.2,22.55a2.33,2.33,0,0,1-4.66,0c0-9.69-4.83-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.32,272.44c-8.53,0-15.21-9.91-15.21-22.56s6.68-22.55,15.21-22.55,15.2,9.91,15.2,22.55a2.33,2.33,0,0,1-4.66,0c0-9.69-4.83-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.82,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M321.6,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55,15.21,9.91,15.21,22.55a2.34,2.34,0,0,1-4.67,0c0-9.69-4.82-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,1,1,0,4.67Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M356.89,272.44c-8.52,0-15.2-9.91-15.2-22.56s6.68-22.55,15.2-22.55,15.21,9.91,15.21,22.55a2.34,2.34,0,0,1-4.67,0c0-9.69-4.83-17.89-10.54-17.89s-10.54,8.2-10.54,17.89,4.83,17.89,10.54,17.89a2.34,2.34,0,0,1,0,4.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.68,323.42c-8.16-1.62-17.32.27-20.59,8.87-2.63,6.92.74,14.42,8,16.25,6.4,1.61,17.44-.36,19.72-7.74,2.61-8.44-8-11.18-13.95-11.68-1.79-.15-1.78,2.65,0,2.8,2.71.23,5.81.38,8.21,1.87,5,3.13,2.94,8.15-1.32,10.55s-10.79,3-15,.34c-4.6-2.93-4.75-9.37-2-13.57,3.61-5.55,10.2-6.17,16.14-5,1.76.35,2.51-2.35.74-2.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.68,323.42c-8.16-1.62-17.32.27-20.59,8.87-2.63,6.92.74,14.42,8,16.25,6.4,1.61,17.44-.36,19.72-7.74,2.61-8.44-8-11.18-13.95-11.68-1.79-.15-1.78,2.65,0,2.8,2.71.23,5.81.38,8.21,1.87,5,3.13,2.94,8.15-1.32,10.55s-10.79,3-15,.34c-4.6-2.93-4.75-9.37-2-13.57,3.61-5.55,10.2-6.17,16.14-5,1.76.35,2.51-2.35.74-2.7Z",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.65,291.21a220.55,220.55,0,0,0,26,28.8c1.32,1.23,3.31-.75,2-2a217.28,217.28,0,0,1-25.57-28.23c-1.07-1.42-3.5,0-2.41,1.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,318.84c5.9-10.49,16.23-19.44,26-26.29,1.46-1,.07-3.46-1.41-2.42-10.16,7.14-20.84,16.36-27,27.29a1.4,1.4,0,0,0,2.41,1.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.65,291.21a220.55,220.55,0,0,0,26,28.8c1.32,1.23,3.31-.75,2-2a217.28,217.28,0,0,1-25.57-28.23c-1.07-1.42-3.5,0-2.41,1.41Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.54,318.84c5.9-10.49,16.23-19.44,26-26.29,1.46-1,.07-3.46-1.41-2.42-10.16,7.14-20.84,16.36-27,27.29a1.4,1.4,0,0,0,2.41,1.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.87,300.16h18.25a1.4,1.4,0,0,0,0-2.79H309.87a1.4,1.4,0,0,0,0,2.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.66,305.35h10.58a1.4,1.4,0,0,0,0-2.8H309.66a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.87,300.16h18.25a1.4,1.4,0,0,0,0-2.79H309.87a1.4,1.4,0,0,0,0,2.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.66,305.35h10.58a1.4,1.4,0,0,0,0-2.8H309.66a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.56,371.8h15.65a1.4,1.4,0,0,0,0-2.8H200.56a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,377.81H220.3a1.4,1.4,0,0,0,0-2.8H200a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,384h10.15a1.4,1.4,0,0,0,0-2.8H200a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.56,371.8h15.65a1.4,1.4,0,0,0,0-2.8H200.56a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,377.81H220.3a1.4,1.4,0,0,0,0-2.8H200a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,384h10.15a1.4,1.4,0,0,0,0-2.8H200a1.4,1.4,0,0,0,0,2.8Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.19,214.79l4.73-.21-2.14,9a24.77,24.77,0,0,1-4.58-4.05,2.29,2.29,0,0,1,.24-3.21Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.41 219.43 98.29 226.75 92.78 223.56 94.92 214.58 100.41 219.43",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.88,
    y: 175.91,
    width: 9.72,
    height: 240.77,
    transform: "translate(-26.87 11.01) rotate(-5.29)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.88,
    y: 175.91,
    width: 9.72,
    height: 240.77,
    transform: "translate(-26.87 11.01) rotate(-5.29)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.24,
    y: 174.11,
    width: 9.72,
    height: 240.77,
    transform: "translate(-26.62 12.79) rotate(-5.29)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.24,
    y: 174.11,
    width: 9.72,
    height: 240.77,
    transform: "translate(-26.62 12.79) rotate(-5.29)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.56,
    y: 175.01,
    width: 9.72,
    height: 240.77,
    transform: "translate(-26.74 11.9) rotate(-5.29)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.56,
    y: 175.01,
    width: 9.72,
    height: 240.77,
    transform: "translate(-26.74 11.9) rotate(-5.29)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.12 158.31 98.41 159.12 89.8 176.87 118.84 174.18 107.12 158.31",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.12 158.31 98.41 159.12 89.8 176.87 118.84 174.18 107.12 158.31",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "102.1 151.51 98.41 159.12 107.12 158.31 102.1 151.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28,165.06c1,1,1.83,1.95,2.69,3s1.68,2,2.5,3c1.65,2,3.19,4.11,4.69,6.26a74,74,0,0,1,7.78,14c.25.64.48,1.31.72,2l.36,1a9.91,9.91,0,0,1,.42,1.84,12.5,12.5,0,0,1-.77,5.87,27.8,27.8,0,0,1-4.48,7.6,62.34,62.34,0,0,1-11.44,10.85l-3.77-4a105.36,105.36,0,0,0,8.12-11.69,22,22,0,0,0,2.44-5.59,2.78,2.78,0,0,0,.05-1.49s0,0,0,0l-.34-.74c-.23-.49-.43-1-.68-1.48a78.26,78.26,0,0,0-7.4-11.69c-1.4-1.91-2.88-3.77-4.38-5.63-.75-.92-1.51-1.84-2.29-2.74l-2.28-2.63Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.93 219.53 172.19 227.96 176.36 224.37 172.94 218.38 167.93 219.53",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84,170q-3.89,7.41-8.08,14.65c-1.37,2.43-2.81,4.82-4.21,7.23l-2.15,3.6-.54.9c-.27.43-.57.94-.84,1.28s-.54.75-.8,1.06-.54.66-.8.95a74.52,74.52,0,0,1-6.44,6.22c-2.19,1.87-4.38,3.69-6.64,5.42-4.47,3.49-9.06,6.74-13.82,9.84l-3.43-4.32,11.85-11.67c1.94-2,3.9-3.88,5.75-5.86a70.18,70.18,0,0,0,5.13-5.88q.29-.36.51-.69c.17-.24.29-.44.41-.64a4.7,4.7,0,0,0,.28-.5l.46-.93,1.85-3.77c1.27-2.49,2.51-5,3.8-7.47q3.83-7.47,8-14.77Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.91,136.22c-.13.58.08,1.13.45,1.23s.78-.3.91-.88-.09-1.13-.46-1.23S164,135.64,163.91,136.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,137.34a22.24,22.24,0,0,0,1.7,5.65,3.39,3.39,0,0,1-2.86-.17Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.44,132.7a.36.36,0,0,1-.2-.06,2.67,2.67,0,0,0-2.48-.16.36.36,0,0,1-.46-.19.36.36,0,0,1,.19-.46,3.41,3.41,0,0,1,3.15.24.34.34,0,0,1,.09.48A.35.35,0,0,1,165.44,132.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.68,138.43c1.26,5.38,2.69,15.22-.93,18.81,0,0,1.68,5.45,11.67,5.45,11,0,5-5.45,5-5.45-6.05-1.43-6.07-5.88-5.19-10.05Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,159.11c-.86-1.72-1.8-3.7,0-4.32,1.94-.68,12.71-1.37,16.48-.1a4,4,0,0,1,2.86,4.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,159.11c-.86-1.72-1.8-3.7,0-4.32,1.94-.68,12.71-1.37,16.48-.1a4,4,0,0,1,2.86,4.78Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,410a9.34,9.34,0,0,1-1.92-.21.16.16,0,0,1-.13-.13.18.18,0,0,1,.07-.18c.08-.06,2-1.44,3.12-1.2a.83.83,0,0,1,.58.41.69.69,0,0,1,0,.83C128.48,409.91,127.75,410,127,410Zm-1.43-.46c1.1.18,2.6.18,2.9-.23,0,0,.12-.16-.05-.45a.49.49,0,0,0-.35-.24A4.59,4.59,0,0,0,125.57,409.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.12,409.82l-.09,0a.16.16,0,0,1-.08-.15c0-.09.09-2.21.92-2.91a.93.93,0,0,1,.74-.23.58.58,0,0,1,.57.47c.16.82-1.24,2.42-2,2.83Zm1.37-3a.6.6,0,0,0-.39.15,4.06,4.06,0,0,0-.78,2.31c.72-.57,1.61-1.78,1.52-2.26,0-.05,0-.17-.27-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.12,410a12.3,12.3,0,0,1-2.26-.21.17.17,0,0,1-.14-.14.18.18,0,0,1,.08-.18c.37-.21,3.63-2.08,4.42-.79a.67.67,0,0,1,0,.77C173,409.89,172.06,410,171.12,410Zm-1.71-.47c1.38.2,3.24.17,3.56-.28,0,0,.1-.14-.05-.39C172.48,408.15,170.5,409,169.41,409.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89,409.82a.19.19,0,0,1-.1,0,.17.17,0,0,1-.07-.16c0-.08.12-2.06,1-2.83a1.2,1.2,0,0,1,1-.3c.49.05.63.3.66.5.14.85-1.53,2.4-2.41,2.8Zm1.68-3a.87.87,0,0,0-.6.23,3.88,3.88,0,0,0-.87,2.27c.88-.54,2-1.77,1.93-2.28,0-.05,0-.18-.36-.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.81 409.64 168.16 409.64 168.23 392.63 160.89 392.63 160.81 409.64",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.7 409.64 124.05 409.64 127.09 392.63 119.74 392.63 116.7 409.64",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.54,408.79h-8.25a.61.61,0,0,0-.61.51l-1.2,6.53a1.13,1.13,0,0,0,1.13,1.3c2.88-.05,4.27-.22,7.9-.22,2.23,0,6.84.24,9.93.24s3.36-3,2.09-3.33c-5.71-1.24-7.91-2.95-9.78-4.57A1.83,1.83,0,0,0,124.54,408.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,408.79h-8a.61.61,0,0,0-.61.51l-1.2,6.53a1.11,1.11,0,0,0,1.11,1.3c2.89-.05,7.06-.22,10.7-.22,4.26,0,7.94.24,12.93.24,3,0,3.73-3,2.46-3.33-5.8-1.26-10.5-1.39-15.58-4.45A3.46,3.46,0,0,0,168.08,408.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74,158.9c-6.83,1.58-14,20.35-14,20.35l14.19,9.48a110.51,110.51,0,0,0,8.54-15.53C141.22,164.61,135.71,157.29,128.74,158.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74,158.9c-6.83,1.58-14,20.35-14,20.35l14.19,9.48a110.51,110.51,0,0,0,8.54-15.53C141.22,164.61,135.71,157.29,128.74,158.9Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13,170.87l-5.87,17.41.67.45s2.68-4,5.53-9.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13,170.87l-5.87,17.41.67.45s2.68-4,5.53-9.33Z",
    style: {
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,191.72c-.06,8.2-.55,18.4-1.77,31.06H133.5c-.51-6,2.15-35.46-4.76-63.88a101.07,101.07,0,0,1,13.09-1.66,145.28,145.28,0,0,1,16.7,0,74.84,74.84,0,0,1,11.37,2s3.36,3.64,4.38,20.71C174.48,183.36,174.59,187.24,174.57,191.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,191.72c-.06,8.2-.55,18.4-1.77,31.06H133.5c-.51-6,2.15-35.46-4.76-63.88a101.07,101.07,0,0,1,13.09-1.66,145.28,145.28,0,0,1,16.7,0,74.84,74.84,0,0,1,11.37,2s3.36,3.64,4.38,20.71C174.48,183.36,174.59,187.24,174.57,191.72Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,191.72c-2.38-4.34-6.7-13.05-6.09-18l5.8,6.28C174.48,183.36,174.59,187.24,174.57,191.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.57,191.72c-2.38-4.34-6.7-13.05-6.09-18l5.8,6.28C174.48,183.36,174.59,187.24,174.57,191.72Z",
    style: {
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.2,165.92c-.62,7,15.25,23.84,15.25,23.84l12.72-10.36a82,82,0,0,0-11.89-15.5C170.84,156.71,162.9,158.08,162.2,165.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.2,165.92c-.62,7,15.25,23.84,15.25,23.84l12.72-10.36a82,82,0,0,0-11.89-15.5C170.84,156.71,162.9,158.08,162.2,165.92Z",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.23 392.64 168.19 401.4 160.85 401.4 160.88 392.64 168.23 392.64",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.74 392.64 127.09 392.64 125.52 401.4 118.17 401.4 119.74 392.64",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,130.15c-1.07,7.24-2.06,11.4.72,16a9.49,9.49,0,0,0,16.79-.89c2.87-6,4.15-16.84-2.16-21.42A9.58,9.58,0,0,0,145,130.15Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.75,126.72a18.26,18.26,0,0,1-7,2.15c-1.83,8.37-6.7,18-14.58,15.23-3-1-6-8.27-6.31-14.72-.52.63-.87,1.45-1.14,1.79a16.28,16.28,0,0,1,.94-8.5c2.18-6.18,3.63-2.08,6-5.83,1.53-2.48,4.25-3.76,9-3.92-1.33.69-1.58,1.8.39,1.64s10.38-.62,15.28,2.69c-3.31.75-1.29,6,3.13,3.2C170.85,123.06,168.85,125.54,166.75,126.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,134.63a8.62,8.62,0,0,0,1.76,5.09c1.49,1.92,3.2,1,3.61-1.16.36-1.92,0-5.24-1.86-6.4S154.08,132.43,154.09,134.63Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.13,117.62a6.13,6.13,0,0,1-4.89-3S140.11,120.48,145.13,117.62Z",
    style: {
      fill: "#1e2a4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,222.78s-6.16,56.14-9.93,77.17c-4.12,23-20,99.76-20,99.76H115.42S125,324.84,127,302c2.15-24.75,6.54-79.26,6.54-79.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,222.78s-6.16,56.14-9.93,77.17c-4.12,23-20,99.76-20,99.76H115.42S125,324.84,127,302c2.15-24.75,6.54-79.26,6.54-79.26Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.83,394.75c.06,0-1.19,5.17-1.19,5.17H114.51l.1-4.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.83,394.75c.06,0-1.19,5.17-1.19,5.17H114.51l.1-4.61Z",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,242.78c-9.57,1.89-7.16,37.84-5.29,56.33,2.28-13.07,5.38-38.22,7.47-56.07A3.34,3.34,0,0,0,154.36,242.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,242.78c-9.57,1.89-7.16,37.84-5.29,56.33,2.28-13.07,5.38-38.22,7.47-56.07A3.34,3.34,0,0,0,154.36,242.78Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,222.78s3.14,54.92,3.2,77.33c.07,23.3-5.12,99.6-5.12,99.6H158.42s-3.35-74.94-4.79-97.82c-1.56-24.95-6.67-79.11-6.67-79.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,222.78s3.14,54.92,3.2,77.33c.07,23.3-5.12,99.6-5.12,99.6H158.42s-3.35-74.94-4.79-97.82c-1.56-24.95-6.67-79.11-6.67-79.11Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,215.72l-3.49.28a1.92,1.92,0,0,0-1.68,2.46l1.44,4.85a2.56,2.56,0,0,0,4,1.28,13.09,13.09,0,0,0,3.73-6.21Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92,390.77h0a.14.14,0,0,1-.12-.14c1.38-21.11,4.58-72.2,4.52-90.52,0-18.75-2.28-60.69-3-73.1a.12.12,0,0,1,.12-.13.13.13,0,0,1,.13.12c.68,12.41,2.91,54.35,3,73.11.06,18.33-3.14,69.42-4.52,90.54A.12.12,0,0,1,167.92,390.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.92,390.77h0a.14.14,0,0,1-.12-.14c1.38-21.11,4.58-72.2,4.52-90.52,0-18.75-2.28-60.69-3-73.1a.12.12,0,0,1,.12-.13.13.13,0,0,1,.13.12c.68,12.41,2.91,54.35,3,73.11.06,18.33-3.14,69.42-4.52,90.54A.12.12,0,0,1,167.92,390.77Z",
    style: {
      fill: "#fafafa",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.07,394.75c.06,0-.5,5.17-.5,5.17H157.43l-.59-4.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.07,394.75c.06,0-.5,5.17-.5,5.17H157.43l-.59-4.61Z",
    style: {
      fill: "#fafafa",
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarvector);
export default __webpack_public_path__ + "static/media/calendarvector.8a0a745e33dd0abeaf91c5de05a6a219.svg";
export { ForwardRef as ReactComponent };